import React, { useEffect, useState } from "react";
import axios from "axios";

const API = "https://api.malidag.com/api/token-icons"; // change this

const TokenIconManager = () => {
  const [address, setAddress] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [list, setList] = useState([]);

  // Load all icons
  const fetchIcons = async () => {
    try {
      const res = await axios.get(API);
      setList(res.data || []);
    } catch (err) {
      console.error("Error loading icons:", err);
    }
  };

  useEffect(() => {
    fetchIcons();
  }, []);

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!address || !iconUrl) {
      return alert("Address and Icon URL required");
    }

    try {
      await axios.post(API, { address, iconUrl });
      alert("Saved!");

      setAddress("");
      setIconUrl("");

      fetchIcons();
    } catch (err) {
      console.error("Error saving icon:", err);
      alert("Save failed");
    }
  };

  return (
    <div style={{ maxWidth: "450px", margin: "30px auto", color: "white" }}>
      <h2>Token Icon Manager</h2>

      {/* Add new icon */}
      <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Token Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
          }}
        />

        <input
          type="text"
          placeholder="Icon URL"
          value={iconUrl}
          onChange={(e) => setIconUrl(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
          }}
        />

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px",
            background: "#1464ff",
            color: "white",
            borderRadius: "10px",
            cursor: "pointer",
          }}
        >
          Save Icon
        </button>
      </form>

      <hr style={{ opacity: 0.3 }} />

      {/* List all icons */}
      <h3>Stored Token Icons</h3>

      {list.map((item) => (
        <div
          key={item.address}
          style={{
            display: "flex",
            alignItems: "center",
            background: "#1c253b",
            padding: "10px",
            borderRadius: "10px",
            marginBottom: "10px",
          }}
        >
          <img
            src={item.iconUrl}
            alt=""
            style={{ width: "32px", height: "32px", borderRadius: "50%", marginRight: "10px" }}
          />

          <div>
            <div><strong>{item.address}</strong></div>
            <div style={{ fontSize: "12px", opacity: 0.7 }}>{item.iconUrl}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TokenIconManager;
